// client/src/utils/cspViolationLogger.ts — NOV 2026
//
// PERCHÉ ESISTE: Chrome stampa i blocchi CSP in una forma criptica e, quando si
// copiano i log, gli URL vengono spesso sostituiti da `<URL>`:
//
//   Connecting to '<URL>' violates the following Content Security Policy
//   directive: "connect-src 'self' <URL> …". The request has been blocked.
//
// Con questo listener ogni violazione viene riportata UNA volta sola, con
// l'URL reale e la direttiva violata, così si capisce subito quale origin
// manca (es. un CDN immagini usato dalle stampe PDF) senza dover indovinare.
//
// Non è un fix: è la diagnosi. Il fix va nella policy
// (`client/vite-plugin-csp-hash.ts`) aggiungendo l'origin legittimo.

const reported = new Set<string>();

export function installCspViolationLogger(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const onViolation = (event: Event) => {
    const e = event as SecurityPolicyViolationEvent;
    const key = `${e.violatedDirective}|${e.blockedURI}`;
    if (reported.has(key)) return;
    reported.add(key);

    const target = e.blockedURI || "(inline)";
    console.warn(
      `[CSP] Richiesta bloccata: ${target} — direttiva: ${e.violatedDirective}` +
        (e.sourceFile ? ` (origine: ${e.sourceFile}:${e.lineNumber})` : ""),
    );
  };

  document.addEventListener("securitypolicyviolation", onViolation, true);
}
